module.exports = __webpack_public_path__ + "static/school-support-receipt-33fa95d92036c3f56d5d2d934aeb6a88.jpg";